module.exports = __webpack_public_path__ + "static/img/activity01-image.b86f4ad1.jpg";